module.exports = __webpack_public_path__ + "static/media/page-banner.f5b5240c.jpg";